import styled from 'styled-components';
import { font, colors } from '@chegg-ui/theme';
import { SelectionMenu } from '@chegg-ui/selectionmenu';
export var Container = styled.div.withConfig({
  componentId: "sc-1up0w33-0"
})(["display:grid;"]);
export var Title = styled.h3.withConfig({
  componentId: "sc-1up0w33-1"
})(["text-align:center;font-size:", ";font-weight:normal;line-height:", ";color:", ";margin-top:0;"], font.size.px16, font.lineHeight.md, colors.dark);
export var Selection = styled(SelectionMenu).withConfig({
  componentId: "sc-1up0w33-2"
})(["span{font-weight:unset;}div[role='radio']{z-index:1;}"]);